module.exports = __webpack_public_path__ + "static/img/steps.3d85011.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/steps.png
// module id = sYcT
// module chunks = 1